import { useProfile } from './useProfile';
import { DateInput, formatDateISO, toDate } from '../../utils/date';
import type { StoredUserSettings } from '@/types';

export function useFormatDate() {
  const { profile } = useProfile();
  
  const formatDate = (date: DateInput): string => {
    const d = toDate(date);
    let dateFormat = 'MM/DD/YYYY';
    
    // Safely extract dateFormat from nested preferences
    if (profile?.notification_preferences && typeof profile.notification_preferences === 'object') {
      const prefs = profile.notification_preferences as StoredUserSettings;
      if (prefs.preferences?.dateFormat) {
        dateFormat = prefs.preferences.dateFormat;
      }
    }
    
    switch (dateFormat) {
      case 'DD/MM/YYYY':
        return d.toLocaleDateString('en-GB'); // DD/MM/YYYY format
      case 'YYYY-MM-DD':
        return formatDateISO(d); // YYYY-MM-DD format
      case 'MM/DD/YYYY':
      default:
        return d.toLocaleDateString('en-US'); // MM/DD/YYYY format
    }
  };

  const formatDateTime = (date: DateInput): string => {
    const d = toDate(date);
    let dateFormat = 'MM/DD/YYYY';
    
    // Safely extract dateFormat from nested preferences
    if (profile?.notification_preferences && typeof profile.notification_preferences === 'object') {
      const prefs = profile.notification_preferences as StoredUserSettings;
      if (prefs.preferences?.dateFormat) {
        dateFormat = prefs.preferences.dateFormat;
      }
    }
    
    switch (dateFormat) {
      case 'DD/MM/YYYY':
        return d.toLocaleDateString('en-GB') + ' ' + d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      case 'YYYY-MM-DD':
        return formatDateISO(d) + ' ' + d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
      case 'MM/DD/YYYY':
      default:
        return d.toLocaleDateString('en-US') + ' ' + d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    }
  };

  return { formatDate, formatDateTime };
}